import { AUTO, Game, Scale, type Types } from 'phaser';
import { TrainAdventureScene } from './scenes/TrainAdventureScene';
import { DEMO_LEVELS, type TrainLevel } from './domain/levelProgression';

const baseConfig: Types.Core.GameConfig = {
  type: AUTO,
  width: 1280,
  height: 720,
  parent: 'game-container',
  backgroundColor: '#b9d7d1',
  scale: {
    mode: Scale.FIT,
    autoCenter: Scale.CENTER_BOTH,
  },
};

export function startGame(
  parent: string,
  gameId: string,
  levels: TrainLevel[] = DEMO_LEVELS,
  restartEnabled = true,
) {
  return new Game({ ...baseConfig, parent, scene: [new TrainAdventureScene(levels, gameId, restartEnabled)] });
}
